module.exports = __webpack_public_path__ + "68092d4110fca98beb037f1a0eda9974.svg";